import Main from "./game/main.es6";

new Main();
